export default "__VITE_ASSET__DRFVDIWi__"